import clickupLogo from "@static/img/clickup.png";
import githubLogo from "@static/img/github.png";
import hubspotLogo from "@static/img/hubspot.png";
import jiraLogo from "@static/img/jira-icon.png";
import linearLogo from "@static/img/linear.png";
import salesforceLogo from "@static/img/salesforce.png";
import topicflowLogo from "@static/img/topicflow-logo-no-text.svg";
import youtrackLogo from "@static/img/youtrack.svg";

import { currentOrganizationVar } from "@cache/cache";
import { classNames } from "@helpers/css";
import { getAssetUrl } from "@helpers/helpers";

import {
  IntegrationLogoType,
  getIntegrationLogoTypeFromProvider,
} from "./integration-logo-helpers";

const IntegrationLogo = ({
  provider,
  size = 4,
  className = "",
}: {
  provider: string;
  size?: number;
  className?: string;
}) => {
  const currentOrganization = currentOrganizationVar();
  const type = getIntegrationLogoTypeFromProvider(provider);

  let iconUrl = null;
  if (type == IntegrationLogoType.Merge) {
    // If the integration type is Merge the provider tell us which integration icon to use.
    iconUrl = currentOrganization?.mergeIntegrationsMetadata?.find(
      (meta) => meta?.sourceProvider === provider,
    )?.iconUrl;
  }

  return type === IntegrationLogoType.Github ? (
    <img
      src={getAssetUrl(githubLogo)}
      alt="GitHub"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type === IntegrationLogoType.Jira ? (
    <img
      src={getAssetUrl(jiraLogo)}
      alt="Jira"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type === IntegrationLogoType.Salesforce ? (
    <img
      src={getAssetUrl(salesforceLogo)}
      alt="Salesforce"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type === IntegrationLogoType.Topicflow ? (
    <img
      src={getAssetUrl(topicflowLogo)}
      alt="Topicflow"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type === IntegrationLogoType.Clickup ? (
    <img
      src={getAssetUrl(clickupLogo)}
      alt="Clickup"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type === IntegrationLogoType.Hubspot ? (
    <img
      src={getAssetUrl(hubspotLogo)}
      alt="Hubspot"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type === IntegrationLogoType.Linear ? (
    <img
      src={getAssetUrl(linearLogo)}
      alt="Linear"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type == IntegrationLogoType.YouTrack ? (
    <img
      src={getAssetUrl(youtrackLogo)}
      alt="YouTrack"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type == IntegrationLogoType.Merge && !!iconUrl ? (
    <img
      src={iconUrl}
      alt={String(provider) || "Integration"}
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : null;
};

export default IntegrationLogo;
